/* global app */
/* global mdc */
/* global $, gui */

function AtlasDialog($rootScope) {

    this.init = function() {}

    this.dialog = undefined;

    this.simpleChoiceDialog = function(dialogDef, yesAction, noAction) {
        $rootScope.$emit("simpleChoiceDialog", { data: dialogDef });

        var dialog = gui.dialogs["simpleChoiceDialog"];

        var listener = function(e) {
            if (e.detail.action == "yes") {
                yesAction();
            }
            else if (e.detail.action == "no") {
                noAction();
            }
        };

        dialog.listen("MDCDialog:closing", listener);

        dialog.listen("MDCDialog:closed", function(e) {
            dialog.unlisten("MDCDialog:closing", listener);
        });

        gui.openDialog("simpleChoiceDialog");
    }

    this.searchUserDialog = function(yesAction, noAction) {
        var data = { selectedUser: {} };
        $rootScope.$emit("searchUserDialog", { data: data });

        var dialog = gui.dialogs["searchUserDialog"];

        var listener = function(e) {
            if (e.detail.action == "yes") {
                yesAction(data);
            }
            else if (e.detail.action == "no") {
                noAction(data);
            }
        };

        dialog.listen("MDCDialog:closing", listener);

        dialog.listen("MDCDialog:closed", function(e) {
            dialog.unlisten("MDCDialog:closing", listener);
        });

        gui.openDialog("searchUserDialog");
    }

    this.simpleTextDialog = function(yesAction, noAction, parameters) {
        var data = { text: {}, data: parameters };
        $rootScope.$emit("simpleTextDialog", { data: data });

        var dialog = gui.dialogs["simpleTextDialog"];

        var listener = function(e) {
            if (e.detail.action == "yes") {
                yesAction(data);
            }
            else if (e.detail.action == "no") {
                noAction(data);
            }
        };

        dialog.listen("MDCDialog:closing", listener);

        dialog.listen("MDCDialog:closed", function(e) {
            dialog.unlisten("MDCDialog:closing", listener);
        });

        gui.openDialog("simpleTextDialog");
    }
    
    this.simpleTextLineDialog = function(yesAction, noAction, parameters) {
        var data = { text: "", parameters: parameters };
        $rootScope.$emit("ACSimpleTextLineDialog::open", data);

        var dialog = gui.dialogs["simpleTextLineDialog"];
        
        var getValResponseListener = $rootScope.$on("ACSimpleTextLineDialog::getValResponse", function(e, d){
            yesAction(d);
        })
        
        var listener = function(e) {
            if (e.detail.action == "yes") {
                $rootScope.$emit("ACSimpleTextLineDialog::getVal");
            }
            else if (e.detail.action == "no") {
                noAction();
            }
            getValResponseListener();
        };

        dialog.listen("MDCDialog:closing", listener);

        dialog.listen("MDCDialog:closed", function(e) {
            dialog.unlisten("MDCDialog:closing", listener);
        });

        gui.openDialog("simpleTextLineDialog");
    }

    this.simpleDisplayDialog = function(yesAction, noAction, parameters) {
        var data = { text: {}, data: parameters };
        $rootScope.$emit("simpleDisplayDialog", { data: data });

        var dialog = gui.dialogs["simpleDisplayDialog"];

        var listener = function(e) {
            if (e.detail.action == "yes") {
                yesAction();
            }
            else if (e.detail.action == "no") {
                noAction();
            }
        };

        dialog.listen("MDCDialog:closing", listener);

        dialog.listen("MDCDialog:closed", function(e) {
            dialog.unlisten("MDCDialog:closing", listener);
        });

        gui.openDialog("simpleDisplayDialog");
    }

    this.yesNo = function(msg, yesAction, noAction) {
        var id = "yes-no-dialog";
        var dialog = $("#" + id);
        var _self = this;
        dialog.find(".mdc-dialog__title").text(msg);
        if (this.dialog == undefined) {
            this.dialog = new mdc.dialog.MDCDialog(document.querySelector('#yes-no-dialog'));
        }

        var listener = function(e) {
            if (e.detail.action == "yes") {
                yesAction();
            }
            else if (e.detail.action == "no") {
                noAction();
            }
        };

        this.dialog.listen("MDCDialog:closing", listener);

        this.dialog.listen("MDCDialog:closed", function(e) {
            _self.dialog.unlisten("MDCDialog:closing", listener);
        });
        this.dialog.open();
    };

    this.init();
}

app.service('AtlasDialog', ['$rootScope', AtlasDialog]);
